<template>
  <footer
    class="legal-footer"
    role="contentinfo"
    aria-label="Rechtliche Informationen"
  >
    <nav aria-label="Rechtliche Links">
      <router-link
        to="/impressum"
        class="legal-link"
      >
        Impressum
      </router-link>
      <span
        class="sep"
        aria-hidden="true"
      >·</span>
      <router-link
        to="/datenschutz"
        class="legal-link"
      >
        Datenschutz
      </router-link>
      <span
        class="sep"
        aria-hidden="true"
      >·</span>
      <router-link
        to="/login"
        class="legal-link"
      >
        Login
      </router-link>
    </nav>
  </footer>
</template>

<script setup>
// reiner Präsentations-Footer
</script>

<style scoped>
.legal-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 12px;
  display: flex;
  justify-content: center;
  padding: 0 12px;
  pointer-events: none;
}
.legal-footer nav {
  background: var(--surface, #FFFFFF);
  border: 1px solid var(--border, #E0E3EA);
  border-radius: 999px;
  padding: 6px 10px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
  pointer-events: auto;
}
.legal-link {
  color: var(--text, #1F2937);
  text-decoration: none;
  font-size: 13px;
  line-height: 18px;
  padding: 0 6px;
}
.legal-link:hover,
.legal-link:focus-visible {
  text-decoration: underline;
  outline: none;
}
.sep {
  color: var(--muted, #6B7280);
  margin: 0 2px;
}
@media (max-width: 480px) {
  .legal-footer { bottom: 8px; }
  .legal-link { font-size: 12px; }
}
</style>
